import TradeOrderPage from '@/views/trade/TradeOrderPage'

export default function TradeOrder() {
  return <TradeOrderPage />
}
